import { formatDate } from '@angular/common'
import { ChangeDetectorRef, Component, OnInit, ViewRef,Input,Output,EventEmitter,Inject } from '@angular/core'
import { MatDialog, MAT_DIALOG_DATA,MatDialogRef } from '@angular/material'
import { ActivatedRoute, ParamMap, Router } from '@angular/router'
import { Subscription,forkJoin, of } from 'rxjs'
import { finalize, takeUntil, tap } from 'rxjs/operators'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { VidalService } from '../../../../../services'
import { BaseDialogComponent } from '../../../../../base/dialog-base/dialog-base.component'
import { AppService,InstructionService, DialogService, StateService, TiersService, ConnectionService } from '../../../../../services'
import { AppState } from '../../../../../core/reducers'
import { AuthNoticeService, AuthService, Login } from '../../../../../core/auth'
import { environment } from '../../../../../../environments/environment'
import {
	Observable,
	BehaviorSubject,	
} from "rxjs";
import { cloneDeep, isEqual  } from 'lodash';
import { User } from '../../../../../core/auth/_models/user.model'

const KEY = 'vidal';


@Component({
	selector: 'atyl-modif-user',
	templateUrl: './modif-user-dialog.component.html',
	styleUrls: ['./modif-user-dialog.component.scss'],
})

@Stringable({
	path: 'views/partials/content/actions/modif-user-dialog',
	key: KEY,
})
export class ModifUserDialog extends BaseDialogComponent implements OnInit {
	user: any;
    userDroits: any;
	@StringableValues(KEY) strings: any
    loading: boolean = false;
    userParams: any={};
    droitsToDelete: number[] = [];
    errors:any = [];
    errorMessage:any = null;
    displayTab:String = 'infos'
	constructor(
        changeDetectorRef: ChangeDetectorRef,
		public dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<ModifUserDialog>,
        dialogService: DialogService,
        private tiersService: TiersService,
        private connectionService : ConnectionService,
        private stateService : StateService,
        private router: Router,

	) {
		super(dialogRef, dialogService, changeDetectorRef)
	}
	ngOnInit() {
        if (this.data) {
			if(this.data.user){
                this.user = this.data.user;
                this.userParams={
                    "nom":this.user.nom,
                    "prenom":this.user.prenom,
                    "sexe":this.user.sexe
                };
            }
            if(this.data.userDroits){
                this.userDroits = cloneDeep(this.data.userDroits);
            }
		}
	}

    submit(){
        if (this.setErrors().length == 0) {
            this.loading = true;
            const modifTiersObservable = this.checkUserInfoChange()
                ? this.tiersService.modifTiers(this.user.id, this.checkUserInfoChange())
                : of(true);
            const modifDroitsObservable = this.getDroitsModified()
                ? this.tiersService.modifDroits(this.user.id,this.getDroitsModified())
                : of(true);
            // Mettre à jour le User une fois que tous les changements sont terminés
            forkJoin([modifTiersObservable,modifDroitsObservable]).subscribe(([modifTiersRes, deleteDroitsRes]) => {
                this.connectionService.user().subscribe((newUser: JSONRpcResponse) => {
                if (newUser) {
                    let _user = cloneDeep(this.user);
                    _user.fullname = newUser.result.firstname + " " + newUser.result.name;
                    _user.nom = newUser.result.name;
                    _user.prenom = newUser.result.firstname;
                    _user.sexe = newUser.result.sex;
                    _user.droits = newUser.result.droits
                    this.stateService.updateUser(_user);
                    this.router.navigateByUrl('/home');
                    this.dialogRef.close();
                }
                this.loading = false;
                });
            });
        }
    }

    setErrors(){
        this.userParams.nom = this.userParams.nom.trim();
        this.userParams.prenom = this.userParams.prenom.trim();
        this.errors = [];
        if(this.userParams.nom.length == 0){
            this.errors.push("Le nom est vide");
        }
        if(this.userParams.prenom.length == 0){
            this.errors.push("Le prénom est vide");
        }
        this.errorMessage="<ul><li>"+this.errors.join("</li><li>")+"</li></ul>";
        return this.errors;
    }

    toggleSelection(droitId: number) {
        const index = this.droitsToDelete.indexOf(droitId);
        if (index === -1) {
            this.droitsToDelete.push(droitId);
        } else {
            this.droitsToDelete.splice(index, 1);
        }
    }

    checkUserInfoChange() {
        var checkedParams: any = {};
        if (this.userParams.nom !== this.user.nom) {
          checkedParams.nom = this.userParams.nom;
        }
        if (this.userParams.prenom !== this.user.prenom) {
          checkedParams.prenom = this.userParams.prenom;
        }
        if (this.userParams.sexe !== this.user.sexe) {
          checkedParams.sexe = this.userParams.sexe;
        }
        console.log("checkedParams", checkedParams);
        if (Object.keys(checkedParams).length === 0) {
          checkedParams = null;
        }
        return checkedParams;
    }

    getDroitsModified() {
        let droitsModified = [];
        if(!isEqual(this.userDroits, this.data.userDroits)){
            for(let idx in this.userDroits){
                if(!isEqual(this.userDroits[idx],this.data.userDroits[idx])){
                    droitsModified.push(this.userDroits[idx]);
                }
            }
        }
        return droitsModified;
    }
}
	
	
